import React from "react";

const DatatablePagination = ({ rows, effectivePage, effectivePerPage, effectiveTotal, totalPages, rowsPerPageOptions, manualPageInput, manualInputPage, setManualInputPage, handlePageChange, handlePerPageChange }) => {
  return (
    <div className="d-flex justify-content-center justify-content-md-end align-items-center w-100 mb-3 mt-3">
      <div className="datatable-pagination-wrapper mx-2 mx-md-3 d-flex flex-column flex-md-row align-items-center gap-3">
        <div className="d-flex align-items-center justify-content-center gap-2 small datatable-pagination-select-container">
          <span className="datatable-pagination-text-primary">Filas por página:</span>
          <select value={effectivePerPage} onChange={handlePerPageChange} className="form-select form-select-sm datatable-pagination-select-input">
            {rowsPerPageOptions.map(opt => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </div>

        <div className="text-muted small datatable-pagination-info text-center">
          Mostrando <strong>{rows.length > 0 ? (effectivePage - 1) * effectivePerPage + 1 : 0}</strong>–<strong>{Math.min(effectivePage * effectivePerPage, effectiveTotal)}</strong> de <strong>{effectiveTotal}</strong> registros
        </div>

        <div className="d-flex flex-wrap align-items-center justify-content-center gap-1 gap-sm-2 small datatable-pagination-controls">
          <button type="button" className="btn btn-sm btn-outline-primary datatable-pagination-btn-custom" onClick={() => handlePageChange(1)} disabled={effectivePage === 1} title="Ir al inicio">
            {"|<"}
          </button>
          <button type="button" className="btn btn-sm btn-outline-primary datatable-pagination-btn-custom" onClick={() => handlePageChange(effectivePage - 1)} disabled={effectivePage <= 1} title="Página anterior">
            {"<"}
          </button>

          <span className="datatable-pagination-text-primary" style={{ fontWeight: 600 }}>
            {manualPageInput ? (
              <>
                Página{" "}
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={effectivePage}
                  // onChange={e => setManualInputPage(e.target.value.replace(/[^0-9]/g, ''))}
                  onChange={e => {
                    const txt = e.target.value.replace(/[^0-9]/g, "");
                    handlePageChange(txt);
                  }}
                  onKeyDown={e => {
                    if (e.key === "Enter") {
                      const val = Number(effectivePage);
                      if (val >= 1 && val <= totalPages) handlePageChange(val);
                      // else setManualInputPage(effectivePage);
                      else handlePageChange(val);
                    }
                  }}
                  className="datatable-pagination-manual-input"
                />{" "}
                de {totalPages}
              </>
            ) : (
              <>
                Página {effectivePage} de {totalPages}
              </>
            )}
          </span>

          <button type="button" className="btn btn-sm btn-outline-primary datatable-pagination-btn-custom" onClick={() => handlePageChange(parseInt(effectivePage) + 1)} disabled={effectivePage >= totalPages} title="Página siguiente">
            {">"}
          </button>
          <button type="button" className="btn btn-sm btn-outline-primary datatable-pagination-btn-custom" onClick={() => handlePageChange(totalPages)} disabled={effectivePage === totalPages} title="Ir al final">
            {">|"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DatatablePagination;
